import dr from "../../assets/people/dr.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "../../assets/css/swiper.css";
import { Pagination, Autoplay } from "swiper";

export default function Testimonials() {
  return (
    <div className="container mb-10 pt-10 md:pt-10 mx-4 md:mx-auto">
      <div>
        <div className="w-full flex flex-col justify-center px-12 md:px-0 md:grid md:grid-flow-row md:grid-flow-col bg-doctio-lightgrey pt-8 md:pt-20 md:px-32 flex pt-0 md:pt-10 md:pb-20 border doctio-grey-border rounded-2xl">
          <Swiper
            pagination={{ clickable: true }}
            loop={true}
            autoplay={{
              delay: 5500,
              disableOnInteraction: false,
            }}
            modules={[Pagination, Autoplay]}
            className="testimonial-slider col-span-2 w-full md:w-full  h-100"
          >
            <SwiperSlide>
              <div className="mb-10">
                <h2 className="text-dxl md:text-d2xl font-bold text-doctio-dark mb-3">
                  “Tak for et virkeligt effektivt arbejdsredskab!”
                </h2>
                <p>
                  <span className="block text-doctio-dark text-dbase font-bold">
                    Christoffer, Læge
                  </span>
                  <span className="block text-doctio-dark text-dbase">
                    Bruger af Doctio
                  </span>
                </p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="mb-10">
                <h2 className="text-dxl md:text-d2xl font-bold text-doctio-dark mb-3">
                  “Mega fedt koncept! Det sparer mig for utrolig meget tid i en
                  travl hverdag i almen praksis.”
                </h2>
                <p>
                  <span className="block text-doctio-dark text-dbase font-bold">
                    Laila, Læge
                  </span>
                  <span className="block text-doctio-dark text-dbase">
                    Bruger af Doctio
                  </span>
                </p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="mb-10">
                <h2 className="text-dxl md:text-d2xl font-bold text-doctio-dark mb-3">
                  “... fantastisk brugbar hjemmeside”
                </h2>
                <p>
                  <span className="block text-doctio-dark text-dbase font-bold">
                    Elisabeth, Konsultationssygeplejeske
                  </span>
                  <span className="block text-doctio-dark text-dbase">
                    Bruger af Doctio
                  </span>
                </p>
              </div>
            </SwiperSlide>
          </Swiper>
          <div className="relative row-span-3 mt-5 md:mt-0 w-full md:w-[36rem] h-full md:pt-0">
            <img
              src={dr}
              alt="Dr. Læge"
              className="md:absolute md:right-0 max-w-full md:w-auto md:right-[-100px] h-auto md:max-w-[407px] max-width-auto bottom-[-15px] md:bottom-[-50px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
